import {Component} from 'react';
import dayjs from 'dayjs';

import http from 'services/http';
import formatMoney from 'utils/formatMoney';

import Tabela from 'components/Financeiro';
import TabelaDescargaEnviada from 'components/Financeiro/TabelaDescargaEnviada';
import TabelaResumo from 'components/Financeiro/TabelaResumo';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import styles from './styles.module.css';
import Swal from "sweetalert2";
import { temModulo2Pra500 } from 'utils/modulos';


export default class index extends Component {
    constructor(props) {
        super(props);

        // Formato que o <input type="date"> entende — um objeto Date renderiza o campo vazio.
        const hoje = dayjs().format('YYYY-MM-DD');

        this.state = {
            startDate: hoje,
            endDate: hoje,
            gerenteId: '',
            cambistaId: '',
            supervisorId: '',
            loteriaId: null,
            categoria: '',
            gerentes: [],
            cambistas: [],
            supervisores: [],
            loterias: [],
            relatorio: [],
            relatorioDescarga: [],
            resumo: null,
            resumoDescarga: null,
            loadingAtivo: false
        };

        this.formatarMoeda = this.formatarMoeda.bind(this);
    }

    componentDidMount() {
        const buscaNivel = async () => {
            const nivel = await localStorage.getItem('nivel');
            this.setState({nivel});
        }
        buscaNivel();

        const nivel = localStorage.getItem('nivel');
        this.buscarCambistas();
        this.buscarLoterias();

        // Gerentes e grupos só existem para o admin da banca — o gerente já é
        // fixado no próprio usuário pela API.
        if (nivel === 'admin') {
            this.buscarGerentes();
            this.buscarSupervisores();
        }
        this.modulos = JSON.parse(localStorage.getItem('usuario'))?.modulosAtivos ?? [];
    }

    formatarMoeda = (valor) => formatMoney(valor);

    buscarGerentes = async () => {
        try {
            const response = await http.get('/usuarios', {
                params: {nivel: 'gerente', resumida: true}
            });

            this.setState({gerentes: response.data.data ?? []});
        } catch (e) {
            console.log(e);
        }
    };

    // Sem escopo traz todos os cambistas; com gerente ou grupo, só os de dentro dele.
    buscarCambistas = async ({gerenteId, supervisorId} = {}) => {
        try {
            const response = await http.get('/usuarios', {
                params: {
                    nivel: 'operador',
                    resumida: true,
                    gerente_id: gerenteId || undefined,
                    supervisor_id: supervisorId || undefined,
                }
            });

            this.setState({cambistas: response.data.data ?? []});
        } catch (e) {
            console.log(e);
        }
    };

    // Grupo e gerente são excludentes: a API aplica os dois com AND e a combinação
    // cruzada devolveria relatório vazio. Trocar qualquer um dos dois zera o cambista
    // e recarrega a lista no escopo do novo filtro, para não sobrar uma seleção de fora.
    mudarSupervisor = (supervisorId) => {
        this.setState({supervisorId, gerenteId: '', cambistaId: ''});
        this.buscarCambistas({supervisorId});
    };

    mudarGerente = (gerenteId) => {
        this.setState({gerenteId, cambistaId: '', supervisorId: ''});
        this.buscarCambistas({gerenteId});
    };

    buscarSupervisores = async () => {
        try {
            const response = await http.get('/supervisores', {params: {resumida: true}});

            this.setState({supervisores: response.data.data ?? []});
        } catch (e) {
            console.log(e);
        }
    };

    buscarLoterias = async () => {
        try {
            const response = await http.get('/loterias', {params: {todas: 1}});
            this.setState({loterias: response.data.data});
        } catch (e) {
            console.log(e);
        }
    };


    buscarFinanceiro = async (e) => {
        try {
            e.preventDefault();

            this.setState({loadingAtivo: true});

            if (!this.state.startDate || !this.state.endDate) return;

            const data_inicial = dayjs(this.state.startDate);
            const data_final = dayjs(this.state.endDate);

            const diferencaDeDias = data_final.diff(data_inicial, 'days');

            if (diferencaDeDias > 91) {
                Swal.fire({
                    type: 'error',
                    title: 'Não foi possível buscar o relatório. Intervalo máximo é de 90 dias!'
                });

                this.setState({loadingAtivo: false});

                return;
            }

            const nivel = localStorage.getItem('nivel');

            if (nivel === "admin" || nivel === "gerente") {
                const response = await http.get('/vendas', {
                    params: {
                        data_inicial: data_inicial.format('YYYY-MM-DD'),
                        data_final: data_final.format('YYYY-MM-DD'),
                        // Gerente e grupo só são enviados pelo admin; para o gerente a
                        // API já fixa o gerente no próprio usuário logado.
                        gerente_id: this.state.gerenteId || undefined,
                        supervisor_id: this.state.supervisorId || undefined,
                        cambista_id: this.state.cambistaId || undefined,
                        loteria_id: this.state.loteriaId || undefined,
                        categoria: this.state.categoria || undefined,
                    }
                });

                const {data: {relatorio, resumo, relatorio_descarga, resumo_descarga}} = response.data;

                this.setState({
                    relatorio,
                    resumo,
                    relatorioDescarga: relatorio_descarga,
                    resumoDescarga: resumo_descarga,
                });
            }

        } catch (e) {
            console.log(e);
        }

        this.setState({
            loadingAtivo: false
        });
    };

    downloadPdf = async () => {
        const doc = new jsPDF();
        doc.setFontSize(24);
        doc.text(`Relatorio Financeiro`, 15, 10);
        doc.autoTable({
            html: `.table`,
            useCss: true
        });

        doc.autoTable({
            html: `.head_table_banca`,
            useCss: true
        });

        doc.autoTable({
            html: `.table_banca`,
            useCss: true
        });

        doc.save(`Financeiro_.pdf`);
    }

    render() {
        return (
            <>
                <div className="titulo-principal">Venda</div>
                <div className="conteudo-principal">
                    <form onSubmit={this.buscarFinanceiro}>
                        <div className="d-flex quatro-colunas justify-content-start">
                            {this.state.nivel === 'admin' && (
                                <>
                                    <div className="form-group">
                                        <label>Grupo Gerentes</label>
                                        <select
                                            onChange={(e) => this.mudarSupervisor(e.target.value)}
                                            className="form-control"
                                            value={this.state.supervisorId}
                                        >
                                            <option value="">Todos</option>
                                            {this.state.supervisores.map((s) => (
                                                <option key={s.id} value={s.id}>
                                                    {s.nome}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label>Gerente</label>
                                        <select
                                            onChange={(e) => this.mudarGerente(e.target.value)}
                                            className="form-control"
                                            value={this.state.gerenteId}
                                        >
                                            <option value="">Todos</option>
                                            {this.state.gerentes.map((u) => (
                                                <option key={u.id} value={u.id}>
                                                    {u.login.toUpperCase()}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </>
                            )}

                            <div className="form-group">
                                <label>Cambista</label>
                                <select
                                    onChange={(e) => this.setState({cambistaId: e.target.value})}
                                    className="form-control"
                                    value={this.state.cambistaId}
                                >
                                    <option value="">Todos</option>
                                    {this.state.cambistas.map((u) => (
                                        <option key={u.id} value={u.id}>
                                            {u.login.toUpperCase()}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <label>Categoria</label>
                                <select
                                    onChange={(e) => this.setState({categoria: e.target.value, loteriaId: null})}
                                    className="form-control"
                                    value={this.state.categoria}
                                >
                                    <option value="">Todos</option>
                                    {this.modulos?.includes('JB') && <option value="jb">Tradicional</option>}
                                    {this.modulos?.includes('Bolão') && <option value="bolao">Bolão</option>}
                                    {this.modulos?.includes('Bolão de Dezena') && <option value="bolao_dezena">Bolão Dezena</option>}
                                    {this.modulos?.includes('Seninha') && <option value="seninha">Seninha</option>}
                                    {this.modulos?.includes('Sena Brasil') && <option value="sena_brasil">Sena Brasil</option>}
                                    {temModulo2Pra500(this.modulos) && <option value="dois_quinhentos">2 Pra 500</option>}
                                    {this.modulos?.includes('Rifa') && <option value="rifa">Rifa</option>}
                                    {this.modulos?.includes('Raspadinha') && <option value="raspadinha">Raspadinha</option>}
                                </select>
                            </div>
                        </div>

                        <div className="d-flex quatro-colunas justify-content-start">
                            {(!this.state.categoria || this.state.categoria === 'jb') && (
                                <div className="form-group">
                                    <label>Extração</label>
                                    <select
                                        onChange={(e) => this.setState({loteriaId: e.target.value || null})}
                                        className="form-control"
                                        value={this.state.loteriaId ?? ''}
                                    >
                                        <option value="">Todos</option>
                                        {this.state.loterias.map((l) => (
                                            <option key={l.id} value={l.id}>
                                                {l.nome}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            <div className="form-group">
                                <label>Data inicial</label>
                                <input
                                    type="date"
                                    value={this.state.startDate}
                                    onChange={(e) => this.setState({startDate: e.target.value})}
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group">
                                <label>Data final</label>
                                <input
                                    type="date"
                                    value={this.state.endDate}
                                    onChange={(e) => this.setState({endDate: e.target.value})}
                                    className="form-control"
                                />
                            </div>

                            {/* Label vazio só para alinhar o botão com os inputs rotulados da linha. */}
                            <div className="form-group">
                                <label>&nbsp;</label>
                                <button
                                    style={{height: '38px'}}
                                    type="submit"
                                    className="btn btn-primary w-100">
                                    Buscar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                {this.state.loadingAtivo ? (
                    <div className="loader"/>
                ) : (
                    <>
                        <Tabela
                            relatorio={this.state.relatorio}
                            resumo={this.state.resumo}
                            formatMoney={this.formatarMoeda}
                            renderResumo={false}
                            mostrarDescarga={this.state.nivel === 'admin'}
                        />
                        {this.state.nivel === 'admin' && (
                            <TabelaDescargaEnviada
                                relatorio={this.state.relatorioDescarga}
                                resumo={this.state.resumoDescarga}
                                formatMoney={this.formatarMoeda}
                            />
                        )}
                        <TabelaResumo
                            resumo={this.state.resumo}
                            formatMoney={this.formatarMoeda}
                        />
                        {this.state.relatorio.length > 0 ? (
                            <button
                                className={`btn btn-primary ${styles.buttonSalvarPDF}`}
                                onClick={this.downloadPdf}>
                                Salvar PDF
                            </button>
                        ) : (
                            <></>
                        )}
                    </>
                )}
            </>
        );
    }
}
